/** @format */

export enum FullCalendarViewType {
    TIME_GRID_WEEK = 'timeGridWeek',
    DAY_GRID_MONTH = 'dayGridMonth',
}

export type HiddenEventPreference = Array<'cancelled'>;
